import React, { useEffect, useState } from "react";
import img from "../Images/d.jpg";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const Hospital = () => {
  const classes = useStyles();
  const API = "https://api.rootnet.in/covid19-in/hospitals/beds";
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(API)
      .then((response) => response.json())
      .then((data) => setData(data.data.regional));
  }, []);

  const renderTable = () => {
    return data.map((data) => {
      return (
        <TableRow>
          <TableCell align="left">{data.state}</TableCell>
          <TableCell align="right">{data.ruralHospitals}</TableCell>
          <TableCell align="right">{data.ruralBeds}</TableCell>
          <TableCell align="right">{data.urbanHospitals}</TableCell>
          <TableCell align="right">{data.urbanBeds}</TableCell>
          <TableCell align="right">{data.totalHospitals}</TableCell>
          <TableCell align="right">{data.totalBeds}</TableCell>

          </TableRow>
        // <tr>
        //   <td>{data.state}</td>
        //   <td>{data.ruralHospitals}</td>
        //   <td>{data.ruralBeds}</td>
        //   <td>{data.urbanHospitals}</td>
        //   <td>{data.urbanBeds}</td>
        //   <td>{data.totalHospitals}</td>
        //   <td>{data.totalBeds}</td>
        // </tr>
      );
    });
  };
  return (
    <div className="p-5">
      <h2 className="text-center">India: Hospitals and its capacity Updates</h2>

      <img src={img} alt="hospital" className="mx-auto img-fluid  d-block" />
      <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>

         
          <TableCell align="left"><h4>State</h4></TableCell>
          <TableCell align="right"><h4>Rural Hospitals</h4></TableCell>
          <TableCell align="right"><h4>Rural Beds</h4></TableCell>
          <TableCell align="right"><h4>Urban Hospitals</h4></TableCell>
          <TableCell align="right"><h4>Urban Beds</h4></TableCell>
          <TableCell align="right"><h4>Total Hospitals</h4></TableCell>
          <TableCell align="right"><h4>total Beds</h4></TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
        {renderTable()}
        </TableBody>
      </Table>
    </TableContainer>
      {/* <div class="table-responsive">
      <table id="dtBasicExample" className="table text-center align-center" width="100%">
        <thead>
          <tr>
            <th>State</th>
            <th>ruralHospitals</th>
            <th>ruralBeds</th>
            <th>urbanHospitals</th>
            <th>urbanBeds</th>
            <th>totalHospitals</th>
            <th>totalBeds</th>
          </tr>
        </thead>
        <tbody>{renderTable()}</tbody>
      </table>
      </div> */}
    </div>
  );
};

export default Hospital;
